import { addDays } from '../lib/reporting';

/**
 * Standalone date-range control (range + quick presets + optional export).
 * Used by pages like DPD handoffs that filter by date only — no region/driver.
 */
export function DateRangeBar({
  from,
  to,
  min,
  max,
  onChange,
  onExport,
}: {
  from: string;
  to: string;
  min?: string;
  max?: string;
  onChange: (next: { from?: string; to?: string }) => void;
  onExport?: () => void;
}) {
  const preset = (days: number) => {
    if (!max) return;
    onChange({ to: max, from: addDays(max, -(days - 1)) });
  };

  return (
    <div className="filter-card">
      <div className="filter-grid filter-grid--dates">
        <div className="filter-block">
          <span className="filter-label">Date range</span>
          <div className="filter-dates">
            <input type="date" value={from} min={min} max={to || max} onChange={(e) => onChange({ from: e.target.value })} />
            <span aria-hidden="true">→</span>
            <input type="date" value={to} min={from || min} max={max} onChange={(e) => onChange({ to: e.target.value })} />
          </div>
          <div className="filter-presets">
            <button type="button" onClick={() => preset(1)}>Last day</button>
            <button type="button" onClick={() => preset(7)}>Last 7 days</button>
            <button type="button" onClick={() => preset(30)}>Last 30 days</button>
          </div>
        </div>
      </div>
      {onExport && (
        <div className="filter-actions">
          <button type="button" className="export-btn" onClick={onExport}>↓ Export</button>
        </div>
      )}
    </div>
  );
}
